// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"185":"903cc36c","271":"27ba5ad2","349":"bb187a5a","399":"555eae26"}[chunkId] + ".chunk.css";
};